<template>
    <div class="desk-main d-flex flex-column flex-grow-1">
        <transition name="show-tile" @after-enter="tileReady = true">
            <main-tile v-if="showTile" key="mainTile" />
        </transition>

        <transition name="show-apps">
            <main-apps v-show="showApps && tileReady" key="mainApps" />
        </transition>

        <main-footer></main-footer>

        <main-debug />
    </div>
</template>

<script>
import MainTile from '@/components/desk-main/main-tile/main-tile';
import MainApps from '@/components/desk-main/main-apps/main-apps';
import MainDebug from '../../components/desk-main/main-debug/main-debug.vue';
import MainFooter from '@/components/desk-main/main-footer/main-footer.vue';

export default {
    name: 'DeskMain',

    components: { MainDebug, MainApps, MainTile, MainFooter },

    data() {
        return {
            // 是否展示磁贴
            showTile: false,

            // 磁贴是否准备完毕
            tileReady: false
        };
    },

    computed: {
        /**
         * 是否展示应用
         * @returns {boolean}
         */
        showApps() {
            return this.$store.state.appManager.currentAppId > 0;
        }
    },

    async mounted() {
        await this.$nextTick();
        this.showTile = true;
    }
};
</script>

<style lang="scss" scoped>
.desk-main {
    position: relative;
}

.show-tile-enter-active,
.show-tile-leave-active {
    transition: all 456ms ease-in-out;
}

.show-tile-enter,
.show-tile-leave-to {
    opacity: 0;
    transform: scale(0);
}

.show-apps-enter-active,
.show-apps-leave-active {
    transition: all 345ms ease-in-out;
}

.show-apps-enter,
.show-apps-leave-to {
    opacity: 0;
    transform: scale(0.5) translateY(100%);
}
</style>
